import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";


import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import ProjectUpdate from "./ProjectUpdate";





export interface ProjectQuotaData {
    block_storage_capacity_gb: number;

    floatingip_max_count: number;
    key_pair_max_count: number;
    metadata_max_count: number;
    network_max_count: number;
    port_max_count: number;
    project_quota_id: string;

    region_id: string;
    router_max_count: number;
    security_group_max_count: number;
    security_group_rule_max_count: number;
    server_group_max_count: number;
    server_group_member_max_count: number;
    snapshot_max_count: number;
    subnet_max_count: number;
    vcpu_max_count: number;
    vm_max_count: number;
    vmemory_max_capacity_mb: number;
    volume_max_count: number;
}


interface ProjectUsersData {
    alias: string;
    email: string;
    fullname: string;
    phone_number: string;
    project_role_type_code: string;
    user_id: string;
    user_role_type_code;

}


export interface ProjectData {
    project_id: string;
    project_name: string;
    project_description: string;
    memory_capacity_mb: number;
    vcpu_count: number;
    vm_count: number;
    vm_image_count: number;
    volume_capacity_gb: number;
    volume_count: number;
    volume_snapshot_count: number;
    create_ts: string,
    update_ts: string,
    project_quotas: ProjectQuotaData[]
    users: ProjectUsersData[]
}

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "PROJECT_SYNC",
        }
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("PROJECT_NAME_TEXT"),
        accessor: "project_name",
        disableSortBy: false,
        style: {
            width: "150px",
            paddingLeft: "20px"
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value}</div>)
    },
    {
        Header: i18n.t("PROJECT_STATE_TEXT"),
        accessor: "activeYn",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {<StatusStableImg style={className.statusImg}/> } Up
            </div>
        )
    },
    {
        Header: i18n.t("PROJECT_USER_COUNT_TEXT"),
        accessor: "users",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{ value ? value.length : 0}</div>)
    },
    {
        Header: i18n.t("INSTANCE_CPU_TEXT"),
        accessor: "vcpu_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.resourceContainer}}>{value || 0} core</div>)
    },
    {
        Header: i18n.t("INSTANCE_MEMORY_TEXT"),
        accessor: "memory_capacity_mb",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.resourceContainer}}>
                {
                    (!value) ? 0 : (value > 10000) ? (value / 1024).toFixed(1).toString() + 'GB' : value + 'MB'
                }
            </div>
        )
    },
    {
        Header: i18n.t("INSTANCE_COUNT_TEXT"),
        accessor: "vm_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.countContainer}}>{value || 0}</div>)
    },
    {
        Header: i18n.t("VM_VOLUME_SIZE_TEXT"),
        accessor: "volume_capacity_gb",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.countContainer}}>{value || 0} GB</div>)
    },
    {
        Header: i18n.t("VOLUME_COUNT_TEXT"),
        accessor: "volume_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.countContainer}}>{value || 0}</div>)
    },
    {
        Header: i18n.t("VOLUME_SNAPSHOT_TYPE_TEXT"),
        accessor: "volume_snapshot_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.countContainer}}>{value || 0}</div>)
    },
    {
        Header: i18n.t("IMAGE_TYPE_TEXT"),
        accessor: "vm_image_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.countContainer}}>{value || 0}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: true,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: true,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    }
];

export const projectUpdateModalContent = {
    title: i18n.t("PROJECT_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <ProjectUpdate />,
}

const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    }
}



export interface ProjectData {

}